import { OBVEventType, type BarDuration, type OBVAnalyzerEvent } from '@einhaus/project314-types';
import type { AuditPreset } from './types';

export const AUDIT_DURATION_OPTIONS: BarDuration[] = ['1m', '5m', '15m', '30m', '60m', '120m', '180m', '240m', '1d'];
export const DEFAULT_SYMBOL = 'DAR';
export const DEFAULT_DURATION: BarDuration = '30m';
export const DEFAULT_END_DATE_TIME = '2026-04-06 22:49:30';
export const DEFAULT_WINDOW_DAYS = 180;
export const DEFAULT_AFTER_HOURS_REMOVAL = true;
export const DEFAULT_FOCUSED_MARKERS_ONLY = true;
export const DEFAULT_FOCUSED_MARKER_CONTEXT_BARS = 10;

export const ALL_OBV_EVENT_TYPES: readonly OBVAnalyzerEvent['type'][] = [
    OBVEventType.crossedAboveSignal,
    OBVEventType.crossedBelowSignal,
    OBVEventType.bullishDivergenceDetected,
    OBVEventType.bearishDivergenceDetected,
    OBVEventType.hiddenBullishDivergence,
    OBVEventType.hiddenBearishDivergence,
    OBVEventType.divergenceConfirmed,
    OBVEventType.divergenceExpired,
    OBVEventType.bullishBreakoutConfirmed,
    OBVEventType.bearishBreakdownConfirmed,
    OBVEventType.enteredAccumulation,
    OBVEventType.enteredDistribution,
    OBVEventType.newLocalHigh,
    OBVEventType.newLocalLow
];

export const OBV_EVENT_TYPE_SET = new Set<string>(ALL_OBV_EVENT_TYPES);

export const AUDIT_PRESETS: AuditPreset[] = [
    {
        duration: '15m',
        endDateTime: '2026-04-06 22:55:48',
        focusDateTime: '2026-03-03 15:15:00',
        label: 'DAR 15m Bullish Cross',
        symbol: 'DAR',
        windowDays: 180
    },
    {
        duration: '15m',
        endDateTime: '2026-04-06 22:55:48',
        focusDateTime: '2026-03-12 09:45:00',
        label: 'NKE 15m Bearish Cross',
        symbol: 'NKE',
        windowDays: 180
    },
    {
        duration: '30m',
        endDateTime: '2026-04-06 22:49:30',
        focusDateTime: '2026-03-27 13:00:00',
        label: 'DAR 30m Bullish Cross',
        symbol: 'DAR',
        windowDays: 180
    },
    {
        duration: '30m',
        endDateTime: '2026-04-06 22:49:30',
        focusDateTime: '2026-04-01 10:00:00',
        label: 'NKE 30m Bearish Cross',
        symbol: 'NKE',
        windowDays: 180
    },
    {
        duration: '1d',
        endDateTime: '2026-04-02 15:59:00',
        focusDateTime: '',
        label: 'AAPL 1d Snapshot',
        symbol: 'AAPL',
        windowDays: 365
    }
];
